import { useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import ActionCard from "@/components/ActionCard";
import { ProfileSkeleton } from "@/components/Skeleton";
import FacilityDataSyncDialog from "../_components/FacilityDataSyncDialog";
import { useFacilityAdminToolsAccess } from "../_utils";

export default function FacilityAdminToolsPage() {
  const { facilityId } = useParams();
  const [isFacilitySyncDialogOpen, setIsFacilitySyncDialogOpen] = useState(false);
  const { canAccessAdminTools, facility, loading } = useFacilityAdminToolsAccess(facilityId);

  if (!facilityId) return null;

  if (loading) return <ProfileSkeleton />;

  if (!canAccessAdminTools || !facility?.legacyId) {
    return <Navigate to={`/facilities/${facilityId}/details`} replace />;
  }

  return (
    <div className="w-full min-h-[70vh]">
      <div className="pt-12" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[90rem]">
        <div className="min-w-0">
          <ActionCard
            actionFn={() => setIsFacilitySyncDialogOpen(true)}
            iconName="sync"
            title="Data Sync"
            text="Trigger facility data synchronization from ServiceBus"
            className="max-w-none"
          />
        </div>
      </div>

      <FacilityDataSyncDialog
        open={isFacilitySyncDialogOpen}
        onClose={() => setIsFacilitySyncDialogOpen(false)}
        facilityName={facility.name}
        legacyId={facility.legacyId}
      />
    </div>
  );
}
